import cx from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export type PillProps = {
  defaultBranch?: string;
  children?: any;
  color?: string;
  style?: any;
  overlayText?: string;
};

const Pill = ({ defaultBranch, children, color, style, overlayText = null }: PillProps) => {
  let overlay = defaultBranch
    ? (<Tooltip>Scan results for default branch &quot;{defaultBranch}&quot;</Tooltip>) : <div />;

  if (overlayText) {
    overlay = (
      <Tooltip>
        <span className="tooltip-issue-counts">{overlayText}</span>
        {defaultBranch && <span className="tooltip-issue-branch margin-top-xs">Scan results for default branch &quot;{defaultBranch}&quot;</span>}
      </Tooltip>);
  }

  return (
    <OverlayTrigger
      placement="top"
      overlay={overlay}
    >
      <span className={cx('label', 'label-rounded', 'label-rounded-squared', 'pill-component', color)} style={style}>
        {children}
      </span>
    </OverlayTrigger>
  );
};

export default Pill;
